'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reduxForm = require('redux-form');

var _components = require('components');

var _applicationForm = require('redux/modules/applicationForm');

var applicationFormActions = _interopRequireWildcard(_applicationForm);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Application = (_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { initialize: _reduxForm.initialize }), _dec2 = (0, _reactRedux.connect)(function () {
  return {};
}, function (dispatch) {
  return (0, _redux.bindActionCreators)(applicationFormActions, dispatch);
}), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Application, _Component);

  function Application() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Application);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Application.__proto__ || (0, _getPrototypeOf2.default)(Application)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (data) {
      _this.props.saveApplicationForm(data).then(function () {
        _this.props.hideForm();
      }).catch(function (err) {
        window.alert('Je nám líto, ale někde se stala chyba :( Zkuste to prosím ještě jednou nebo napište na info@nenudimse.cz. ' + (0, _stringify2.default)(err));
      });
    }, _this.handleRepeat = function () {
      _this.props.showForm();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Application, [{
    key: 'render',
    value: function render() {
      this.props.initialize('application-form', {});

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, { title: 'P\u0159ihl\xE1\u0161ka', link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/prihlaska' }] }),
        _react2.default.createElement(
          'header',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'div',
            { className: 'container' },
            _react2.default.createElement(
              'h1',
              null,
              'P\u0159ihl\xE1\u0161ka'
            ),
            _react2.default.createElement(
              'p',
              null,
              'P\u0159ihlaste sv\xE9 d\xEDt\u011B na d\u011Btsk\xFD nebo p\u0159\xEDm\u011Bstsk\xFD t\xE1bor konaj\xEDc\xED se b\u011Bhem l\xE9ta nebo na pravideln\xE9 tr\xE9ninky do sportovn\xED p\u0159\xEDpravky.'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(_components.ApplicationForm, { onSubmit: this.handleSubmit, repeat: this.handleRepeat })
        )
      );
    }
  }]);
  return Application;
}(_react.Component), _class2.propTypes = {
  initialize: _react.PropTypes.func.isRequired,
  saveApplicationForm: _react.PropTypes.func.isRequired,
  showForm: _react.PropTypes.func.isRequired,
  hideForm: _react.PropTypes.func.isRequired
}, _temp2)) || _class) || _class);
exports.default = Application;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/Application.js
// module id = 1102
// module chunks = 0